<template>
  <div id="pageRoot">
    <span class="normalTheme pageInstruction" style="left: 90px; top: 70px;">
      <p>Señala dónde está escrito el nombre del instrumento.</p>
    </span>

    <img
    style="width: 160px; top: 180px; left: 30px"
    class="pageElement basicItem01"
    src="/pages/img/sordovio/assets_p15/maracas.svg"
    />

    <div id="radio0">
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; left: 223px; top: 190px;"
        >MARACA
        <input type="radio" name="maraca"
        ref="1-1" 
        v-on:change="saveOption('radios', 1, 1)" 
        :onload="loadOption('radios', 1, 1)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; left: 223px; top: 243px;"
        >MARIONETA
        <input type="radio" name="maraca"
        ref="1-2" 
        v-on:change="saveOption('radios', 1, 2)" 
        :onload="loadOption('radios', 1, 2)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; left: 223px; top: 296px;"
        >MANZANA
        <input type="radio" name="maraca"
        ref="1-3" 
        v-on:change="saveOption('radios', 1, 3)" 
        :onload="loadOption('radios', 1, 3)"
        />
        <span class="toggleButton"></span>
      </label>
    </div>

    <img
    style="width: 140px; top: 480px; left: 30px"
    class="pageElement basicItem01"
    src="/pages/img/sordovio/assets_p15/trompeta.svg"
    />

    <div id="radio1">
      <label class="toggleButtonContainer pageElement" id="toggle11"
        >TROMPETA
        <input type="radio" name="trompeta"
        ref="2-1" 
        v-on:change="saveOption('radios', 2, 1)" 
        :onload="loadOption('radios', 2, 1)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle12"
        >TROMPO
        <input type="radio" name="trompeta"
        ref="2-2" 
        v-on:change="saveOption('radios', 2, 2)" 
        :onload="loadOption('radios', 2, 2)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle13"
        >TRISTE
        <input type="radio" name="trompeta"
        ref="2-3" 
        v-on:change="saveOption('radios', 2, 3)" 
        :onload="loadOption('radios', 2, 3)"
        />
        <span class="toggleButton"></span>
      </label>
    </div>

    <img
    style="width: 170px; top: 190px; left: 500px"
    class="pageElement basicItem01"
    src="/pages/img/sordovio/assets_p15/violin.svg"
    />

    <div id="radio2">
      <label class="toggleButtonContainer pageElement" id="toggle21"
        >VIOLÍN
        <input type="radio" name="violin"
        ref="3-1" 
        v-on:change="saveOption('radios', 3, 1)" 
        :onload="loadOption('radios', 3, 1)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle22"
        >VIOLETA
        <input type="radio" name="violin"
        ref="3-2" 
        v-on:change="saveOption('radios', 3, 2)" 
        :onload="loadOption('radios', 3, 2)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" id="toggle23"
        >VIENTO
        <input type="radio" name="violin"
        ref="3-3" 
        v-on:change="saveOption('radios', 3, 3)" 
        :onload="loadOption('radios', 3, 3)"
        />
        <span class="toggleButton"></span>
      </label>
    </div>

     <img
    style="width: 160px; top: 520px; left: 500px"
    class="pageElement basicItem01"
    src="/pages/img/sordovio/assets_p15/pandereta.svg"
    />

    <div id="radio3">
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; left: 710px; top: 497px;"
        >PANADERO
        <input type="radio" name="pandereta"
        ref="4-1" 
        v-on:change="saveOption('radios', 4, 1)" 
        :onload="loadOption('radios', 4, 1)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; left: 710px; top: 550px;"
        >PANDERETA
        <input type="radio" name="pandereta"
        ref="4-2" 
        v-on:change="saveOption('radios', 4, 2)" 
        :onload="loadOption('radios', 4, 2)"
        />
        <span class="toggleButton"></span>
      </label>
      <label class="toggleButtonContainer pageElement" style="width: 42.89px; height: 42.89px; left: 710px; top: 603px;"
        >PANA
        <input type="radio" name="pandereta"
        ref="4-3" 
        v-on:change="saveOption('radios', 4, 3)" 
        :onload="loadOption('radios', 4, 3)"
        />
        <span class="toggleButton"></span>
      </label>
    </div>

  </div>
</template>
<style scoped>
#toggle11 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 710px;
  top: 186px;
}
#toggle12 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 710px;
  top: 240px;
}
#toggle13 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 710px;
  top: 293px;
}
#toggle21 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 223px;
  top: 497px;
}
#toggle22 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 223px;
  top: 551px;
}
#toggle23 {
  position: absolute;
  width: 42.89px;
  height: 42.89px;
  left: 223px;
  top: 604px;
}
</style>
<script>
  export default {
    methods:{
      dbId(name, group){
        return `${this.$parent.pageID()}-${name}-${group}`
      },
      async loadOption(name, group, option) {
        var id = this.dbId(name, group);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[group+"-"+option].checked=value.option==option;

        console.log("option loaded: " + id + ", option:" + option + ", selected:" + value.option);
      },
      saveOption(name, group, option) {
        var id = this.dbId(name, group);

        this.$db.options.put({
              id: id,
              option: option
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + option);
      }
    }
  }
</script>